import React, { Component, Fragment } from "react";

import { PAGES, GENERAL_CONTENT } from "../../constants/constants";
import { gaPageview } from "../../utils/dev";

export default class GeneralPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageUrl: props.match.url.substring(1).replace("/", ""),
      page: ""
    };
    this.page = null;
  }
  componentDidMount() {
    const { pageUrl } = this.state;
    this.setState({ page: PAGES[pageUrl] }, () => {
      const page = PAGES[pageUrl];
      document.title = page.title;
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      gaPageview(this.props.location);
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.url !== this.props.match.url) {
      const pageUrl = this.props.match.url.substring(1);
      const page = PAGES[pageUrl];
      this.setState({ pageUrl: pageUrl, page: page });
      document.title = page.title;
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      gaPageview(this.props.location);
    }
  }

  render() {
    const { page } = this.state;
    const pageContent = GENERAL_CONTENT[page.content];
    return (
      <Fragment>
        <div className="container general-content">
          <div className="row">
            <div className="col-sm-12">{pageContent}</div>
          </div>
        </div>
      </Fragment>
    );
  }
}
